import React from 'react';
import { Handle, Position } from 'reactflow';
import TickerAutocomplete from '../TickerAutocomplete';

const externalOptions = [
  { value: 'vix', label: 'VIX' },
  { value: 'gold', label: 'Gold (GLD)' },
  { value: 'us_dollar', label: 'USD Index (UUP)' },
  { value: 'treasury_10y', label: '10Y Treasury' },
  { value: 'treasury_2y', label: '2Y Treasury' },
  { value: 'treasury_spread', label: '10Y-2Y Spread' },
  { value: 'fed_funds_rate', label: 'Fed Funds Rate' },
  { value: 'unemployment', label: 'Unemployment' },
  { value: 'consumer_sentiment', label: 'Consumer Sentiment' },
];

export default function RelativeStrengthNode({ data, id }) {
  const onChange = (field, value) => {
    if (data.onChange) data.onChange(id, field, value);
  };

  const compareType = data.compare_type || 'ticker';
  const mode = data.mode || 'ratio';

  return (
    <div style={{
      padding: 12,
      borderRadius: 8,
      border: '2px solid #059669',
      background: 'var(--card)',
      minWidth: 210,
      fontSize: 13,
      color: 'var(--text)',
    }}>
      <div style={{ fontWeight: 700, marginBottom: 8, color: '#34d399' }}>
        💪 Relative Strength
      </div>

      <div style={{ display: 'flex', gap: 4, marginBottom: 8 }}>
        {['ticker', 'external'].map((t) => (
          <button
            key={t}
            onClick={() => onChange('compare_type', t)}
            style={{
              flex: 1,
              padding: '3px 0',
              fontSize: 11,
              borderRadius: 4,
              border: '1px solid var(--border)',
              background: compareType === t ? '#059669' : 'var(--surface)',
              color: compareType === t ? '#fff' : 'var(--muted)',
              cursor: 'pointer',
              fontWeight: compareType === t ? 700 : 400,
            }}
          >
            {t === 'ticker' ? 'Ticker' : 'External'}
          </button>
        ))}
      </div>

      {compareType === 'ticker' ? (
        <TickerAutocomplete
          className="nodrag nopan"
          value={data.compare_value || ''}
          onChange={(val) => onChange('compare_value', val.toUpperCase())}
          onPick={(sym) => onChange('compare_value', sym)}
          classes="stock,fx"
          placeholder="e.g. SPY, XLK"
          menuMinWidth={220}
          style={{ width: '100%', padding: 4, background: 'var(--surface)', color: 'var(--text)', border: '1px solid var(--border)', borderRadius: 4, fontSize: 12, boxSizing: 'border-box' }}
        />
      ) : (
        <select
          value={data.compare_value || 'vix'}
          onChange={(e) => onChange('compare_value', e.target.value)}
          style={{ width: '100%', padding: 4, background: 'var(--surface)', color: 'var(--text)', border: '1px solid var(--border)', borderRadius: 4, fontSize: 12 }}
        >
          {externalOptions.map((o) => (
            <option key={o.value} value={o.value}>{o.label}</option>
          ))}
        </select>
      )}

      <div style={{ marginTop: 8, display: 'flex', gap: 6 }}>
        <select
          value={mode}
          onChange={(e) => onChange('mode', e.target.value)}
          style={{ flex: 1, padding: 4, background: 'var(--surface)', color: 'var(--text)', border: '1px solid var(--border)', borderRadius: 4, fontSize: 12 }}
        >
          <option value="ratio">Ratio</option>
          <option value="roc">% Change of Ratio</option>
        </select>
        {mode === 'roc' && (
          <input
            type="number"
            min={2}
            value={data.period ?? 20}
            onChange={(e) => onChange('period', Math.max(2, parseInt(e.target.value, 10) || 20))}
            style={{ width: 60, padding: 4, background: 'var(--surface)', color: 'var(--text)', border: '1px solid var(--border)', borderRadius: 4, fontFamily: 'var(--font-mono)' }}
          />
        )}
      </div>

      <div style={{ marginTop: 6, fontSize: 10, fontStyle: 'italic', color: 'var(--muted)', lineHeight: 1.4 }}>
        Ratio = this asset's price / the comparison's price. Use "% Change of Ratio" for relative momentum.
      </div>

      <Handle type="source" position={Position.Right} id="output" style={{ background: '#059669' }} />
    </div>
  );
}
